export default {
  // AI智能识别
  aiGlobalRecognition: {
    // 按钮文本
    buttonText: 'AI识别',
    loadingText: 'AI识别中...',

    // 反馈消息模板
    successTemplate: 'AI识别完成，本次识别填充了{filled}个字段',
    softFailure: '填充失败，请检查输入文本',
    requestError: '请求失败：{status} {error}',
    fieldRecognized: '已识别',

    // 弹窗配置
    modal: {
      title: 'AI智能识别',
      width: '600px',
      maskClosable: false
    },

    // 内容文本
    content: {
      description: '请粘贴需要识别的文本内容，AI将自动提取其中的物流信息并填充到相应字段中。',
      supportedItems: '支持识别：港口信息、船公司、箱型箱量、重量、直达/中转、航线、货物类型、服务条款等信息',
      processing: 'AI正在识别中，请稍候...'
    },

    // 占位符
    placeholder: '请粘贴需要识别的文本内容，例如：\n从 CNSHA/Shanghai 到 USLAX/Los Angeles\n船公司：马士基\n箱型：2x20GP + 1x40HC\n重量：1200 KGS\n直达航线，服务条款：DDP\n货物类型：普货',

    // 按钮
    buttons: {
      cancel: '取消',
      confirm: '确认'
    },

    // 消息提示
    messages: {
      success: 'AI识别完成，已自动填充相关字段',
      error: 'AI识别失败，请重试',
      emptyInput: '请输入需要识别的文本'
    }
  },

  // 重置功能
  reset: {
    buttonText: '重置',
    confirmTitle: '确认重置',
    confirmMessage: '确认要重置并清空所有字段吗？',
    confirmButton: '确认',
    cancelButton: '取消',
    successMessage: '已重置所有字段'
  },

  // 枚举翻译
  enums: {
    // 约价性质枚举
    pricingNature: {
      selfPricing: 'FAK',
      customerPricing: '客户约价',
      overseasAgentPricing: '海外代理约价',
      noPricing: '无约价',
      peerPricing: '同行约价',
      bcoContract: 'NAC/FIX',
      afcPricing: 'AFC约价',
      mixedPricing: '配比约价'
    },

    // 适用品名枚举
    commodity: {
      fak: 'FAK',
      dangerousGoods: '危险品',
      specialContainer: '特种柜',
      frozenGoods: '冷冻货',
      chemicalGoods: '化工品',
      textileGoods: '纺织品',
      other: '其他'
    },

    // 舱保枚举
    spaceGuarantee: {
      guarantee20: '有 (20 TEU/月)',
      guarantee50: '有 (50 TEU/月)',
      guarantee100: '有 (100 TEU/月)',
      guarantee300: '有 (300 TEU/月)',
      noGuarantee: '无'
    },

    // 合约状态枚举
    contractStatus: {
      enabled: '启用',
      disabled: '禁用'
    }
  },

  // 尾程运价查询详情页
  lastmileDetail: {
    // 页面标题
    pageTitle: {
      create: '新增尾程运价',
      copy: '复制尾程运价',
      edit: '编辑尾程运价',
      view: '尾程运价详情'
    },
    // 按钮
    buttons: {
      back: '返回',
      addAddress: '添加地址',
      removeAddress: '删除地址',
      expandAddress: '展开地址',
      collapseAddress: '收起地址'
    },
    // 基本信息
    basicInfo: {
      title: '基本信息',
      priceNo: '尾程运价编号',
      priceNoPlaceholder: {
        copy: '复制后将重新生成，格式：LMR2506250001',
        create: '后端自动生成，格式：LMR2506250001'
      }
    },
    // 地址信息
    address: {
      title: '配送地址',
      addressItem: '配送地址 {index}',
      addressType: '地址类型',
      addressTypeOptions: {
        thirdParty: '第三方地址',
        amazonWarehouse: '亚马逊仓库',
        easyWarehouse: '易仓',
        notSelected: '未选择'
      },
      warehouseCode: '仓库代码',
      warehouseCodePlaceholder: {
        amazon: '请选择亚马逊仓库',
        easy: '请选择易仓'
      },
      postalCode: '邮编',
      detailAddress: '详细地址',
      country: '国家',
      state: '州',
      city: '城市',
      district: '区域',
      // 地址预览
      preview: {
        addressType: '地址类型：',
        warehouseCode: '仓库代码：',
        postalCode: '邮编：',
        detailAddress: '详细地址：'
      }
    },
    // 目的港信息
    destinationInfo: {
      title: '目的港信息',
      pod: '目的港',
      podPlaceholder: '请选择目的港',
      podRequired: '请选择目的港',
      agent: '代理名称',
      agentPlaceholder: '请输入代理名称',
      agentRequired: '请输入代理名称',
      etd: 'ETD',
      etdPlaceholder: '请选择预计开船日',
      eta: 'ETA',
      etaPlaceholder: '请选择预计到港日',
      validPeriod: '有效期',
      validPeriodPlaceholder: ['开始日期', '结束日期'],
      validPeriodRequired: '请选择有效期',
      remarks: '备注',
      remarksPlaceholder: '请输入备注信息'
    },
    // 运价信息
    rateInfo: {
      title: '运价信息',
      // 按箱型计费
      containerBilling: {
        title: '按箱型计费项目',
        addItem: '添加计费项目',
        removeItem: '删除计费项目',
        minItemsWarning: '至少需要保留一个运价项目'
      },
      // 非按箱型计费
      nonContainerBilling: {
        title: '非按箱型计费项目',
        addItem: '添加计费项目',
        removeItem: '删除计费项目',
        minItemsWarning: '至少需要保留一个计费项目'
      },
      // 表格列
      columns: {
        feeName: '费用名称',
        feeNamePlaceholder: '请选择费用名称',
        currency: '币种',
        currencyPlaceholder: '自动填充',
        unit: '计费单位',
        unitPlaceholder: '请选择计费单位',
        price: '单价',
        pricePlaceholder: '请输入单价',
        specialNote: '特殊备注',
        specialNotePlaceholder: '特殊备注'
      },
      // 箱型标签
      containerTypes: {
        '20gp': '20GP',
        '40gp': '40GP',
        '40hc': '40HC',
        '45hc': '45HC',
        '40nor': '40NOR',
        '20nor': '20NOR',
        '20hc': '20HC',
        '20tk': '20TK',
        '40tk': '40TK',
        '20ot': '20OT',
        '40ot': '40OT',
        '20fr': '20FR',
        '40fr': '40FR'
      }
    },
    // 费用名称
    feeNames: {
      lastMileFee: '尾程费',
      deliveryFee: '派送费',
      storageFee: '仓储费',
      handlingFee: '装卸费',
      fuelFee: '燃油费',
      documentFee: '文件费',
      customsFee: '报关费',
      inspectionFee: '商检费',
      operationFee: '操作费',
      insuranceFee: '保险费'
    },
    // 消息提示
    messages: {
      missingParams: '缺少必要参数',
      dataLoadFailed: '数据加载失败',
      copyDataLoadFailed: '复制数据加载失败',
      atLeastOneAddress: '至少需要保留一个地址',
      priceFormat: 'LMR2506250001'
    }
  },

  // 根级别通用字段
  freeContainerDays: '免用箱天数',
  demurrageFreeDays: '免堆存天数',

  // 配送地址类型
  deliveryAddressType: {
    thirdParty: '第三方地址',
    amazon: '亚马逊仓库',
    yicang: '易仓'
  },

  // 费用试算
  costTrial: {
    title: '费用试算',
    boxTypeConfig: '箱型箱量配置',
    feeDetails: '费用明细',
    feeSummary: '费用汇总',
    totalFee: '总费用',
    toCny: '折合人民币',
    exchangeRate: '汇率',
    loadRateFailed: '加载汇率失败，请重试',
    exchangeRateValidPeriod: '汇率有效期',
    rateValidPeriod: '运价有效期',
    contactAdmin: '如有疑问,请联系公司管理员',
    noSuitableExchangeRate: '没有合适的汇率无法折合人民币',
    exchangeRateNotExist: '汇率不存在',
    messages: {
      noFeeData: '暂无费用数据，无法进行费用试算'
    },
    placeholders: {
      selectBoxType: '请选择箱型'
    },
    columns: {
      feeCategory: '费用类型',
      feeName: '费用名称',
      currency: '币种',
      bill: '票',
      box: '箱'
    },
    subtotal: '小计',
    categoryMap: {
      trunkLine: '干线',
      prePort: '港前',
      lastMile: '尾程'
    }
  },

  // 供应商选择
  supplierSelection: {
    title: '选择询价目标',
    tabs: {
      business: '商务',
      supplier: '供应商'
    },
    searchPlaceholder: '搜索供应商名称、联系人关键词',
    managerSearchPlaceholder: '搜索姓名/手机/邮箱',
    noManagers: '暂无匹配的商务负责人',
    filter: '筛选',
    more: '更多',
    selectAll: '全选',
    preferred: '优秀供应商',
    region: '区域',
    contactInfo: '联系信息',
    contact: '联系人',
    phone: '电话',
    email: '邮箱',
    address: '地址',
    establishedDate: '成立时间',
    registeredCapital: '注册资本',
    evaluation: '供应商评价',
    reviews: '{count}条评价',
    productQuality: '产品质量',
    priceCompetitiveness: '价格竞争力',
    deliveryTimeliness: '交付及时性',
    serviceAttitude: '服务态度',
    noData: '暂无数据',
    selectSupplier: '请选择供应商查看详情',
    selectedCount: '已选择 {count} 个供应商',
    cancel: '取消',
    confirm: '确认选择',
    confirmOnly: '确认',
    notSet: '未设置',
    noContacts: '暂无联系人',
    selectAtLeastOneContact: '请至少选择一个联系人',
    loadFailed: '加载供应商列表失败',
    selectManagerFirst: '请选择一位商务负责人',
    loadManagersFailed: '加载商务负责人失败',
    messages: {
      missingInquiryId: '缺少询价单ID',
      selectSupplierContactFirst: '请先选择供应商联系人',
      sendEmailSuccess: '已向{count}个联系人发送询价邮件',
      sendEmailFailed: '发送询价邮件失败，请重试'
    }
  }
}
